<template>
    <svg
      :class="customClass"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M6 8l6 6 6-6" />
      <path d="M6 14l6 6 6-6" />
    </svg>
  </template>
  
  <script>
  export default {
    name: "DoubleArrowDown",
    props: {
      customClass: {
        type: String,
        default: "w-6 h-6",
      },
    },
  };
  </script>
  